module.exports = __webpack_public_path__ + "img/behind the firepower.5467c564.png";